import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { SpinLoading } from "antd-mobile";

const ProtectedRoute = ({ children, requiredRole }) => {
    const { user, userRole, loading } = useAuth();
    
    if (loading) {
        return <div><SpinLoading></SpinLoading></div>;
    }

    if (!user) {
        return <Navigate to="/member-login" />;
    }

    if (requiredRole) {
        if (userRole === "admin" && requiredRole !== "admin") {
            return <Navigate to="/admin-dashboard" />;
        } else if (userRole === "member" && requiredRole !== "member") {
            return <Navigate to="/member-dashboard" />;
        } else if (userRole === "coach" && requiredRole !== "coach") {
            return <Navigate to="/coach-dashboard" />;
        } else if (userRole !== requiredRole) {
            return <Navigate to="/access-denied" />;
        }
    }

    return children;
};

export default ProtectedRoute;